import { render, staticRenderFns } from "./ButtonTodayLowestPrice.vue?vue&type=template&id=1cf5e3e5&scoped=true&"
import script from "./ButtonTodayLowestPrice.vue?vue&type=script&lang=ts&"
export * from "./ButtonTodayLowestPrice.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonTodayLowestPrice.vue?vue&type=style&index=0&id=1cf5e3e5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf5e3e5",
  null
  
)

export default component.exports